export { AddExtrasModal as default } from 'components/add-extras-modal';
